import { ExpiringStorage } from '@oneaudi/stck-store';
import { getScsUrlPartsFromConfiguration } from '../../../hooks';
const fillMarker = (fillColor) => {
    return {
        url: `data:image/svg+xml;charset=UTF-8,%3Csvg width='44' height='43' viewBox='0 0 44 43' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M44 0H0V36H14.9289L22 43.0711L29.0711 36H44V0Z' fill='%23${fillColor}'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M29.816 14.344C30.824 13.48 32.12 13 33.56 13C36.872 13 39.56 15.688 39.56 19C39.56 22.312 36.872 25 33.464 25C32.072 25 30.728 24.472 29.72 23.656C28.712 24.52 27.416 25 25.976 25C24.584 25 23.24 24.472 22.232 23.656C21.224 24.52 19.928 25 18.488 25C17.096 25 15.752 24.472 14.744 23.656C13.736 24.52 12.44 25 11 25C7.688 25 5 22.312 5 19C5 15.688 7.688 13 11 13C12.392 13 13.736 13.48 14.792 14.344C15.8 13.48 17.096 13 18.536 13C19.928 13 21.272 13.48 22.28 14.344C23.288 13.48 24.584 13 26.024 13C27.464 13 28.808 13.48 29.816 14.344ZM10.952 14.344C8.408 14.344 6.344 16.456 6.344 19C6.344 21.544 8.408 23.656 10.952 23.656C12.008 23.656 13.016 23.32 13.784 22.696C13.016 21.688 12.536 20.392 12.536 19C12.536 17.608 13.016 16.312 13.784 15.304C12.968 14.68 12.008 14.344 10.952 14.344ZM15.704 22.696C16.472 21.688 16.952 20.392 16.952 19C16.952 17.608 16.472 16.312 15.704 15.304C16.472 14.68 17.48 14.344 18.536 14.344C19.592 14.344 20.552 14.68 21.368 15.304C20.6 16.312 20.12 17.608 20.12 19C20.12 20.392 20.6 21.688 21.368 22.696C20.6 23.32 19.592 23.656 18.536 23.656C17.432 23.656 16.472 23.272 15.704 22.696ZM24.488 19C24.488 20.392 24.008 21.688 23.24 22.696C24.008 23.272 24.968 23.656 26.072 23.656C27.128 23.656 28.136 23.32 28.904 22.696C28.136 21.688 27.656 20.392 27.656 19C27.656 17.608 28.136 16.312 28.904 15.304C28.088 14.68 27.128 14.344 26.072 14.344C25.016 14.344 24.008 14.68 23.24 15.304C24.008 16.312 24.488 17.608 24.488 19ZM30.728 22.696C31.544 23.32 32.504 23.656 33.56 23.656C36.152 23.656 38.216 21.544 38.168 19C38.168 16.408 36.104 14.344 33.56 14.344C32.504 14.344 31.496 14.68 30.728 15.304C31.496 16.312 31.976 17.608 31.976 19C31.976 20.392 31.496 21.688 30.728 22.696ZM14.744 21.688C14.216 20.92 13.88 20.008 13.88 19C13.88 17.992 14.216 17.08 14.744 16.312C15.272 17.08 15.608 17.992 15.608 19C15.608 20.008 15.272 20.92 14.744 21.688ZM21.416 19C21.416 20.008 21.752 20.92 22.28 21.688C22.808 20.92 23.144 20.008 23.144 19C23.144 17.992 22.808 17.08 22.28 16.312C21.752 17.08 21.416 17.992 21.416 19ZM29.816 21.688C29.288 20.92 28.952 20.008 28.952 19C28.952 17.992 29.288 17.08 29.816 16.312C30.344 17.08 30.68 17.992 30.68 19C30.68 20.008 30.344 20.92 29.816 21.688Z' fill='white'/%3E%3C/svg%3E`,
        anchor: new google.maps.Point(22, 43),
        strokeWeight: 0,
        scale: 1,
    };
};
export const getMarkerIcon = (dealerStatus) => {
    let markerIcon;
    switch (dealerStatus) {
        case 'disabled':
            markerIcon = fillMarker('b3b3b3');
            break;
        case 'unchecked':
            markerIcon = fillMarker('666666');
            break;
        case 'checked':
            markerIcon = fillMarker('000000');
            break;
        case 'focused':
            markerIcon = fillMarker('F50537');
            break;
        case 'hovered':
            markerIcon = fillMarker('4c4c4c');
            break;
        default:
            break;
    }
    return markerIcon;
};
export const getRadiusCircleIcon = (map, lat, long, radius, defaultRadius, zeroDealersFound) => {
    return new google.maps.Circle({
        strokeWeight: 0,
        fillColor: '#B3B3B3',
        fillOpacity: zeroDealersFound ? 0 : 0.4,
        center: { lat, lng: long },
        map,
        clickable: false,
        radius: Number(radius || defaultRadius) * 1000,
    });
};
export const getClusterIcon = () => {
    const iconCluster = {
        url: "data:image/svg+xml,%3Csvg width='44' height='43' viewBox='0 0 44 43' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M44 0H0V36H14.9289L22 43.0711L29.0711 36H44V0Z' fill='black'/%3E%3C/svg%3E",
    };
    return iconCluster;
};
export const updateMarkerIcons = (dealersList, markersRef) => {
    dealersList.forEach((item) => {
        var _a;
        const itemMarkerRef = (_a = markersRef === null || markersRef === void 0 ? void 0 : markersRef.find((marker) => {
            return marker.dealerId === item.dealerId;
        })) === null || _a === void 0 ? void 0 : _a.markerRef;
        const itemMarkerIcon = getMarkerIcon(item.status);
        itemMarkerRef === null || itemMarkerRef === void 0 ? void 0 : itemMarkerRef.setIcon(itemMarkerIcon);
        if (item.status === 'disabled') {
            itemMarkerRef === null || itemMarkerRef === void 0 ? void 0 : itemMarkerRef.setClickable(false);
        }
        else {
            itemMarkerRef === null || itemMarkerRef === void 0 ? void 0 : itemMarkerRef.setClickable(true);
        }
    });
};
export const moveMapToSearchedLatLong = (latLong, map) => {
    map === null || map === void 0 ? void 0 : map.fitBounds(latLong);
};
export const setDealerStatusToFocused = (condition) => {
    return condition;
};
export const setDealerStatus = (firstCondition, secondCondition) => {
    return firstCondition ? 'disabled' : secondCondition ? 'checked' : 'unchecked';
};
export const areSomeCarsAvailable = (dealersList, filterData) => {
    let carsAreAvailable = false;
    if (dealersList && filterData) {
        dealersList.forEach((item) => {
            var _a, _b, _c;
            const dealerFilterData = (_b = (_a = filterData.groups) === null || _a === void 0 ? void 0 : _a.dealers) === null || _b === void 0 ? void 0 : _b.members;
            const dealerCarsCount = ((_c = dealerFilterData === null || dealerFilterData === void 0 ? void 0 : dealerFilterData[`dealer.${item.id}`]) === null || _c === void 0 ? void 0 : _c.count) || 0;
            if (dealerCarsCount > 0) {
                carsAreAvailable = true;
            }
        });
    }
    return carsAreAvailable;
};
export const scrollDealerListItemToTop = (dealerItemsRef, dealerListRef, selectedDealer, dealersList) => {
    var _a, _b, _c;
    const foundDealerItem = dealerItemsRef.current.find((elem) => elem.dataset.dealerId === selectedDealer.dealerId);
    const currentDealerStatus = (_a = dealersList === null || dealersList === void 0 ? void 0 : dealersList.find((item) => {
        return item.dealerId === selectedDealer.dealerId;
    })) === null || _a === void 0 ? void 0 : _a.status;
    const newDealerStatusIsFocused = setDealerStatusToFocused(currentDealerStatus === 'unchecked');
    const dealerItemTop = foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.getBoundingClientRect().top;
    const dealerListTop = (_b = dealerListRef === null || dealerListRef === void 0 ? void 0 : dealerListRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top;
    if (dealerItemTop &&
        dealerListTop &&
        newDealerStatusIsFocused &&
        selectedDealer.source === 'marker') {
        (_c = dealerListRef === null || dealerListRef === void 0 ? void 0 : dealerListRef.current) === null || _c === void 0 ? void 0 : _c.scrollBy({
            top: dealerItemTop - dealerListTop,
        });
    }
};
export const createDealersData = (dealersListt, filterDealerData) => {
    return dealersListt.map((item) => {
        const foundDealerItem = filterDealerData[item.dealerId];
        return foundDealerItem
            ? Object.assign(Object.assign({}, item), { count: foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.count, status: setDealerStatusToFocused(item.status === 'focused' &&
                    (foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.count) > 0 &&
                    (foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.active) === true)
                    ? 'focused'
                    : setDealerStatus((foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.count) === 0, foundDealerItem.active) }) : Object.assign({}, item);
    });
};
export const doDealerDataDiffer = (incomingData, currentData) => {
    return JSON.stringify(incomingData) !== JSON.stringify(currentData);
};
export const setRadiusMarker = (previousRadiusMarker, setPreviousRadiusMarker, map, lat, long, radius, defaultRadius, zeroDealersFound) => {
    previousRadiusMarker === null || previousRadiusMarker === void 0 ? void 0 : previousRadiusMarker.setMap(null);
    setPreviousRadiusMarker(null);
    const circle = getRadiusCircleIcon(map, lat, long, radius, defaultRadius, zeroDealersFound);
    setPreviousRadiusMarker(circle);
    const circleLatLong = circle.getBounds();
    if (circleLatLong)
        moveMapToSearchedLatLong(circleLatLong, map);
};
export const removeRadiusMarker = (previousRadiusMarker, setPreviousRadiusMarker) => {
    previousRadiusMarker === null || previousRadiusMarker === void 0 ? void 0 : previousRadiusMarker.setMap(null);
    setPreviousRadiusMarker(null);
};
export const changeIconFormerlyFocusedMarker = (dealersList, markersRef) => {
    var _a, _b;
    const prevFocusedMarkerId = (_a = dealersList.find((item) => {
        return item.status === 'focused';
    })) === null || _a === void 0 ? void 0 : _a.dealerId;
    const prevFocusedMarkerRef = (_b = markersRef.find((item) => {
        return item.dealerId === prevFocusedMarkerId;
    })) === null || _b === void 0 ? void 0 : _b.markerRef;
    const checkedIcon = getMarkerIcon('checked');
    prevFocusedMarkerRef === null || prevFocusedMarkerRef === void 0 ? void 0 : prevFocusedMarkerRef.setIcon(checkedIcon);
};
export const changeIconNewSelectedMarker = (markersRef, selectedDealer, newDealerStatus) => {
    var _a;
    const clickedMarkerRef = (_a = markersRef.find((item) => {
        return item.dealerId === selectedDealer.dealerId;
    })) === null || _a === void 0 ? void 0 : _a.markerRef;
    const newMarkerStatusIcon = getMarkerIcon(newDealerStatus);
    clickedMarkerRef === null || clickedMarkerRef === void 0 ? void 0 : clickedMarkerRef.setIcon(newMarkerStatusIcon);
};
export const updateLocationSearchInputLocalStorage = (localStorageIdentifier, keyToUpdate, valueToUpdate) => {
    if (!valueToUpdate)
        return;
    const localStorage = new ExpiringStorage(localStorageIdentifier, 30);
    const inputFromLocalStorage = localStorage.readEntry();
    if (inputFromLocalStorage) {
        inputFromLocalStorage[keyToUpdate] = valueToUpdate;
        localStorage.writeEntry(inputFromLocalStorage);
    }
    else {
        const inputDataObj = {};
        inputDataObj[keyToUpdate] = valueToUpdate;
        localStorage.writeEntry(inputDataObj);
    }
};
export const setAddressFromLatLngGeocoder = (position, inputRef, localStorageLocationSearchInputKey, setLocationInputValue, context) => {
    const geocoder = new google.maps.Geocoder();
    const latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results) {
            const formattedAddress = results[0].formatted_address;
            const addressWithoutCountry = formattedAddress.substring(0, formattedAddress.lastIndexOf(','));
            if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)
                inputRef.current.value = addressWithoutCountry;
            if (setLocationInputValue && context) {
                setLocationInputValue(addressWithoutCountry);
                context.setSearchedCoords({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    autolocateMe: true,
                });
            }
            updateLocationSearchInputLocalStorage(localStorageLocationSearchInputKey, 'placeId', results[0].place_id);
        }
        else {
            console.warn(`No place for latLng ${status} found`);
        }
    });
};
export const initializeInitialStateFromLocalStorage = (inputRef, inputDataFromLocalStorage, setRadius, setSearchedCoords) => {
    inputRef.current.value = inputDataFromLocalStorage.inputName;
    setRadius(inputDataFromLocalStorage.radius);
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ placeId: inputDataFromLocalStorage.placeId }, (results, status) => {
        if (status === 'OK' && results) {
            setSearchedCoords({
                latitude: results[0].geometry.location.lat(),
                longitude: results[0].geometry.location.lng(),
            });
        }
        else {
            console.warn(`No placeId ${status} found`);
        }
    });
};
export const shouldBeUsedFilterDataWithoutClearingDealers = (changedRadius, firstAutocompleteSearch, hasSearchedLocationOnOverlayOpening) => {
    let useFilterDataWithoutClearingDealers = false;
    if ((changedRadius && !firstAutocompleteSearch) || hasSearchedLocationOnOverlayOpening) {
        useFilterDataWithoutClearingDealers = true;
    }
    return useFilterDataWithoutClearingDealers;
};
export const initializeMap = (mapRefNode, isMobile) => {
    const center = { lat: 54.526, lng: 15.2551 };
    const zoom = 2;
    const mapInstance = new google.maps.Map(mapRefNode, {
        center,
        zoom,
        mapTypeControl: false,
        streetViewControl: false,
        disableDefaultUI: false,
        zoomControl: !isMobile,
        scaleControl: false,
        scrollwheel: false,
        draggable: true,
        disableDoubleClickZoom: true,
        fullscreenControl: false,
    });
    return mapInstance;
};
export const initializeAutocomplete = (country, inputRef, localStorageLocationSearchInputKey, setSearchedCoords, isMas) => {
    const options = {
        componentRestrictions: { country },
        types: ['(regions)'],
    };
    const autocomplete = new google.maps.places.Autocomplete(inputRef.current, options);
    autocomplete.addListener('place_changed', () => {
        var _a;
        const place = autocomplete.getPlace();
        const placeId = place.place_id;
        if (placeId) {
            updateLocationSearchInputLocalStorage(localStorageLocationSearchInputKey, 'placeId', placeId);
        }
        if (isMas) {
            updateLocationSearchInputLocalStorage(localStorageLocationSearchInputKey, 'inputName', inputRef.current.value);
        }
        const placeGeo = (_a = place === null || place === void 0 ? void 0 : place.geometry) === null || _a === void 0 ? void 0 : _a.location;
        if (placeGeo) {
            setSearchedCoords({
                latitude: placeGeo.lat(),
                longitude: placeGeo.lng(),
                autolocateMe: false,
            });
        }
    });
};
export const setLocationFilterToDefaultState = (vtpConfiguration, envConfig, clearAllDealerFilters, context, inputRef, isMas) => {
    const scsUrlParts = getScsUrlPartsFromConfiguration(vtpConfiguration, envConfig);
    const localStorageLocationSearchInputKey = isMas
        ? `VTP_${scsUrlParts === null || scsUrlParts === void 0 ? void 0 : scsUrlParts.marketPath}_mandatoryLocationSearch--input`
        : `VTP_${scsUrlParts.marketPath}_locationSearch--input`;
    const localStorage = new ExpiringStorage(localStorageLocationSearchInputKey, 30);
    const { setWholeMarketDealersFetch, setRadius, setPrevSearchedCoords, setSearchedCoords } = context;
    inputRef.current.value = '';
    localStorage.clearStorage();
    setRadius(undefined);
    setPrevSearchedCoords(undefined);
    setSearchedCoords(undefined);
    clearAllDealerFilters().then(() => setWholeMarketDealersFetch(true));
};
export const extractGoogleMapsAuthParams = (queryParams) => {
    const params = new URLSearchParams(queryParams);
    return {
        googleMapsApiKey: params.get('key'),
        googleMapsClient: params.get('client'),
        googleMapsChannel: params.get('channel'),
    };
};
export const hasGeoLocation = (activeFilter) => {
    return activeFilter && activeFilter.geo;
};
export const persistLocationInput = (activeFilter, vtpConfiguration, envConfig) => {
    if (typeof window === 'undefined' ||
        typeof window.google === 'undefined' ||
        typeof activeFilter === 'undefined') {
        return;
    }
    const scsUrlParts = getScsUrlPartsFromConfiguration(vtpConfiguration, envConfig);
    const enabledMandatoryAreaSearch = vtpConfiguration.enableMandatoryAreaSearch || false;
    const localStorageLocationSearchInputKey = enabledMandatoryAreaSearch
        ? `VTP_${scsUrlParts === null || scsUrlParts === void 0 ? void 0 : scsUrlParts.marketPath}_mandatoryLocationSearch--input`
        : `VTP_${scsUrlParts === null || scsUrlParts === void 0 ? void 0 : scsUrlParts.marketPath}_locationSearch--input`;
    if (window.localStorage.getItem(localStorageLocationSearchInputKey)) {
        return;
    }
    const geoData = activeFilter.geo.values;
    const latitude = geoData[0];
    const longitude = geoData[1];
    const radius = geoData[2];
    const inputName = geoData[4];
    const geocoder = new google.maps.Geocoder();
    const latlng = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
    geocoder.geocode({ location: latlng }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            if (results[1]) {
                const localStorage = new ExpiringStorage(localStorageLocationSearchInputKey, 30);
                const placeId = results[1].place_id;
                const storeValue = {
                    placeId,
                    inputName,
                    radius,
                };
                localStorage.writeEntry(storeValue);
            }
        }
        else {
            console.log(`Geocoder failed due to: ${status}`);
        }
    });
};
